// extracted by mini-css-extract-plugin
export var col = "style-module--col--8d928";
export var content = "style-module--content--830cf";
export var sub = "style-module--sub--a8cf6";